<template>
  <section id="faq-section">
    <h1 class="title">{{$resx('FaqText')}}</h1>
    <h2 class="subtitle">{{$resx('FaqSubtitleText')}}</h2>
    <div class="faq-header" v-if="model.isSHClient===true" v-html="$resx('FaqSecureHolidayClientText')"></div>
    <div class="faq-header" v-if="model.isSHClient===false" v-html="$resx('FaqSecureHolidayNotClientText')"></div>
    <div v-if="isLoading">
      <i class="loading material-icons">cached</i>
    </div>
    <div v-else>
      <reception :reception="model.reception" v-on:update-items="onFaqReceptionUpdated"></reception>
      <animals :animals="model.animals" v-on:update-items="onFaqAnimalsUpdated"></animals>
      <pools :pools="model.pools" v-on:update-items="onFaqPoolsUpdated"></pools>
      <children :items="model.childrenamenities" v-on:update-items="onFaqChildrenAmenitiesUpdated"></children>
      <faq-items v-for="categ in model.categories" :key="categ.id" :category="categ" v-on:update-category="onFaqCategoryUpdated"></faq-items>
    </div>
  </section>
</template>
<script>
import faqItems from '../components/faq/faqItems.vue'
import children from '../components/faq/faqChildren.vue'
import animals from '../components/faq/animals.vue'
import pools from '../components/faq/pools.vue'
import reception from '../components/faq/reception.vue'
import faqServices from '../services/faqServices'

require('../assets/faq.less')

export default {
  data () {
    return {
      isLoading: false,
      model: {
        categories: [],
        childrenamenities: [],
        animals: null,
        pools: null,
        reception: null,
        isSHClient: null
      }
    }
  },
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    },
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  watch: {
    // détecter un changement de camping
    currentCampingId: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadFaq()
      }
    }
  },
  methods: {
    // charge la liste des semaines
    loadFaq () {
      var self = this
      this.isLoading = true
      faqServices.loadFaq(this.currentCampingId)
        .then(response => {
          self.model = response
          // console.log('data loaded')
          self.isLoading = false
        })
        .catch(error => {
          self.isLoading = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    },
    // mise a jour d'une categorie
    onFaqCategoryUpdated (categ) {
      const self = this

      this.model.categories.forEach(function (elt, index) {
        if (elt.id === categ.id) {
          self.model.categories.splice(index, 1, categ)
        }
      })
    },
    // mise a jour des structures d'acceuil des enfants
    onFaqChildrenAmenitiesUpdated (items) {
      // console.log('onFaqChildrenAmenitiesUpdated', items)
      this.model.childrenamenities = items
    },
    // mise a jour des données sur les animaux
    onFaqAnimalsUpdated (animals) {
      // console.log('onFaqAnimalsUpdated', animals)
      this.model.animals = animals
    },
    // mise a jour des données sur les piscines
    onFaqPoolsUpdated (pools) {
      // console.log('onFaqPoolsUpdated', pools)
      this.model.pools = pools
    },
    // mise a jour des données sur la réception
    onFaqReceptionUpdated (reception) {
      // console.log('onFaqReceptionUpdated', reception)
      this.model.reception = reception
    }

  },
  components:
  {
    'faq-items': faqItems,
    children: children,
    animals: animals,
    pools: pools,
    reception: reception
  },
  created: function () {
    // validateur pour les entiers
    this.$validator.extend('isIntBigger', (value, [otherValue]) => {
      const result = parseInt(value) > parseInt(otherValue)
      // console.log('isIntBigger', value, otherValue)
      return result
    }, {
      hasTarget: true
    })
    // validateur pour les dates
    this.$validator.extend('isDateBigger', (value, [otherValue]) => {
      const result = value > otherValue
      // console.log('isDateBigger', value, otherValue)
      return result
    }, {
      hasTarget: true
    })
  },
  mounted: function () {
    this.$store.commit('app/setPage', 'faq')
    this.loadFaq()
  }
}
</script>
